(function () {
  document.querySelectorAll('.nt-pslider').forEach(function (slider) {
    var track = slider.querySelector('[data-nt-ps-track]');
    var prevBtn = slider.querySelector('[data-nt-ps-prev]');
    var nextBtn = slider.querySelector('[data-nt-ps-next]');
    if (!track) return;

    function scrollByCard(direction) {
      var card = track.querySelector('.nt-pslider__card');
      if (!card) return;
      var cardWidth = card.getBoundingClientRect().width;
      var gap = parseFloat(getComputedStyle(track).columnGap || 0);
      track.scrollBy({ left: direction * (cardWidth + gap), behavior: 'smooth' });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        scrollByCard(-1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        scrollByCard(1);
      });
    }
  });
})();
